import { type AccountInfoData } from "../../AccountSelection/AccountSelectionTabelView/api/GetAccountList";

export const dropdownAccountSelectionToAccountData = (
  selection: string,
  availableAccounts?: AccountInfoData[]
): AccountInfoData[] => {
  const accounts: AccountInfoData[] = [];
  selection
    .trim()
    .split(" ")
    .forEach((id) => {
      const accountData = availableAccounts?.find((account) => account.id === id);
      if (accountData) {
        accounts.push(accountData);
      }
    });
  return accounts;
};
